import React from 'react';
import { Row, Col, Form, InputNumber  } from 'antd';
import styles from './index.module.css';

interface propeType {
  dataSource:{
    title?:string,
    firstName?:string,
    secondName?:string
  },
  index?:number
}

const WeekStay = (props:propeType) => {
  const { dataSource } = props
  return (
    <Row gutter={24} style={{marginTop:-30}}> 
      <Col span={2}>{dataSource.title}</Col>
      <Col span={3} className="col-margin">
          <Form.Item 
            name={[`${props.index}`,`${dataSource.firstName}`]}
            rules={[
              { pattern: /^([1-9]$)|(^[1-3][0-9]$)|(^[4][0-5])$/, message: 'This field should be a number' }
            ]}>
            <InputNumber min={1} max={35} />
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={3} className="col-margin">
          <Form.Item 
            name={[`${props.index}`,`${dataSource.secondName}`]} 
            rules={[
              { pattern: /^[0-9]\d*$/, message: 'This field should be a number' }
            ]}>
            <InputNumber min={1} max={255} />
          </Form.Item>
        </Col>
    </Row>
  )
}

export default WeekStay;



